<template>
  <header class="absolute inset-x-0 top-0">
    <div class="mx-auto flex max-w-7xl items-center justify-center p-8">
      <div class="flex items-center">
        <a href="/" class="-m-1.5 p-1.5">
          <img src="@/assets/logo.png" class="h-12 w-auto">
        </a>
      </div>
    </div>
  </header>
  <div class="relative mt-[7rem] max-w-screen-sm py-2 px-8 mx-auto">
    <div v-if="loading" class="flex flex-col items-center">
      <svg class="m-4 size-10 animate-spin text-theme-pink" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  name: 'ResponseContainer',
  props: {
    loading: Boolean,
  },
}
</script>